<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('topics.topicsStateChange')"></page-title>
    </div>

    <jet-form-section @submitted="updateState()">

        <template #form>
            <!-- Card Topic State -->
            <form-card :title="$t('topics.state')" :description="$t('topics.topicsStateDescription')">

                <radio-list
                    v-model="form.updateState.state"
                    :items="states" />

            </form-card>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button"
                        class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>
            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import RadioList from "@/Shared/Components/RadioList";


const states = [
    { name: "Offen", description: "Das Thema wurde noch nicht besprochen.", code: "open" },
    { name: "In Bearbeitung", description: "Die Abklärungen zu diesem Thema sind in Gange.", code: "in_process" },
    { name: "Blockiert", description: "Das Thema kann aktuell nicht bearbeitet werden.", code: "blocked" },
    { name: "Abgeschlossen", description: "Das Thema wurde vollständig abgeklärt.", code: "completed" }
];

export default defineComponent({
    props: ["topic", "apartment"],
    inheritAttrs: false,
    emits: ["closeModal", "reloadTopics"],
    layout: MainLayout,
    components: {
        PageTitle,
        FormCard,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        RadioList
    },
    data() {
        return {
            form: useForm({
                updateState: {
                    state: this.states.find(s => s.code === this.topic.state)
                }
            })
        };
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        updateState() {
            this.form.updateState.state = this.form.updateState.state.code;
            this.form.put(this.route("advisors.topics.update", { apartment: this.apartment.uuid, topic: this.topic.uuid }), {
                preserveScroll: true,
                onSuccess: () => {
                    this.$notify({
                        group: "success",
                        title: "actions.success",
                        text: "topics.updated"
                    });

                    this.$emit("reloadTopics");
                }
            });
        }
    },
    setup() {
        return {
            states
        };
    }
});
</script>

<style scoped></style>
